//api file to categorize all CRUD api calls through axios 
import axios from 'axios';

const url = 'https://food-experiences-backend-2.herokuapp.com/posts';
// const url = 'http://localhost:5000/posts'

export const fetchPosts = () => axios.get(url);
export const createPost = (newPost) => axios.post(url, newPost);
export const likePost = (id) => axios.patch(`${url}/${id}/likePost`);
export const updatePost = (id, updatedPost) => axios.patch(`${url}/${id}`, updatedPost);
export const deletePost = (id) => axios.delete(`${url}/${id}`);